export default __webpack_public_path__ + "static/media/check_off.29e0e62f.svg";